export default __webpack_public_path__ + "static/media/femimed_background2.d5592716.webp";